

import React, { Component } from 'react';
// import { Box } from 'reactjs-admin-lte'
import { Label,Badge, Radio, ControlLabel, Form, Row, Col, FormGroup, FormControl, Button, Popover, OverlayTrigger } from 'react-bootstrap'
import { tableHelper } from '../../report/helpers'
import ReactPaginate from 'react-paginate'
import FontAwesome from 'react-fontawesome'
import Select from 'react-select'
// import Moment from 'moment';
import DatePicker from '../../../component/element/DatePicker'
import SelectObject from '../../../component/element/SelectObject'
import ReportStore from '../../../stores/ReportStore';
import ReportMobileTable from '../../report/ReportMobileTable'
import { Checkbox } from 'react-icheck'
import {connect} from 'react-redux'
import JSWorkDocViewModal from 'view/workdoc/JSWorkdocViewModal';
import _ from 'lodash'
import DNDRowItem from '../../ssp/RowItem'
import WorkdocStore from 'stores/WorkdocStore';
const NotificationSystem = require('react-notification-system');
const mockJson = {
  jobState: {
    0: 'รอเริ่มงาน',
    1: 'กำลังซ่อม',
    2: 'ซ่อมเสร็จในขั้นตอน',
    3: 'หยุดชั่วคราว',
  },

  workerList: [
    {
      workerId: '1xx',
      workerName: 'แจ๊ค'
    },
    {
      workerId: '2xx',
      workerName: 'อ๋อม'
    }
  ],

  summary: {
    missingCount: 16,
    appointmentCount: 10,
    noShowCount: 20,
    finishCount: 0,
    unassignCount: 10,
  },

  dataList: [ {
    work_no:'...',
    car_registration_no:'...'
  }    
  ]
};

// const mockDataList = [
//   {
//     workNo: '',
//     registrationNo: '',
//     brandModel: '',
//     colorCode: '',
//     startDate: '',
//     finishDate: '',
//     deliverDate: '',
//     fixLevel: 'M ซ่อมกลาง',
//     dismanlingState: '1',
//     hitState: '0',
//     trapState: '1',
//     groundState: '1',
//     mixColorState: '2',
//     paintState: '3',
//     assemblyState: '0',
//     polishState: '0',
//     cleanState: '1',
//     qcState: '1',
//     jobState: '0',
//     parkingStatus: '1'
//   }
// ]
// const NO_SHOW = 1
// const PRESENT_APPOINTMENT = 2
// const NOT_YET_APPOINTMENT = 3
// const JOB_DONE = 4


// const jobStyle = {
//   0: { background: 'rgb(227, 186, 130)' },
//   1: { background: 'rgb(252, 254, 206)' },
//   2: { background: 'rgb(125, 195, 150)' },
//   3: { background: 'rgb(170, 195, 220)' },
// }

const STATE_MODE = {
  STATE_PERCENTAGE_MODE : 1,
  STATE_CHECK_MODE : 2,
}

// const WORK_STATE_DEFAUILT = [{ title: 'รื้อ', field: 'dismanlingState' },
//         { title: 'เคาะ', field: 'hitState' },
//         { title: 'โป๊ว', field: 'trapState' },
//         { title: 'พื้น', field: 'groundState' },
//         { title: 'ผสมสี', field: 'mixColorState' },
//         { title: 'พ่น', field: 'paintState' },
//         { title: 'ประกอบ', field: 'assemblyState' },
//         { title: 'ขัดสี', field: 'polishState' },
//         { title: 'ล้าง', field: 'cleanState' },
//         { title: 'QC', field: 'qcState' }]

const localStorageKey = 'kkc.jobControlBoard' 
const localStorageKey2 = 'kkc.jobControlBoard.showMec'  
// const localStorageKey3 = 'kkc.jobControlBoard.filter'
const FILTER_TB = {
  createJobState:false,
  dismanlingState:false,
  hitState:false,
  trapState:false,
  groundState:false,
  mixColorState:false,
  paintState:false,
  assemblyState:false,
  polishState:false,
  cleanState:false,
  qcState:false
}
const FILTER_RECHECK_TB = {
  printRecvCarDocState:false,
  quotationState:false,
  crateJobState:false,
  purchasingState:false,
  partState:false,
  financeState:false,
  recvPaymentState:false,
  reproFinState:false
}
class JobControlBoardTable extends Component {

  constructor(...args) {
    super(...args)
    this.defaultHeaderTitles = [
      { title: this.props.messages['Fixing Job No'], field: 'work_no', sorting: true, direction:'', onClick:this.onSortClick.bind(this) },
      { title: this.props.messages['Car Registration'], field: 'car_registration_no' },
      { title: this.props.messages['Brand/Model'], field: 'car_detail' },
      { title: this.props.messages['Customer'], field: 'customer_name' },
      { title: this.props.messages['Work Date'], field: 'work_date', sorting: true, direction:'', onClick:this.onSortClick.bind(this) },
      { title: this.props.messages['Work Duration'], field: 'work_duration',className:'text-center' },
      { title: this.props.messages['Appointment'], field: 'appointment_date', sorting: true, direction:'', onClick:this.onSortClick.bind(this) },
      { title: this.props.messages['Damage Level'], field: 'damage_level' }        
    ]
    if(!this.props.showWorkNo){
      this.defaultHeaderTitles.splice(0, 1);
    }
    if(this.props.defaultHeaderTitles){
      this.defaultHeaderTitles = this.props.defaultHeaderTitles
    }
    
    this.state = {
      hideFilterNoSel:false,
      status_list:'',
      status_options:[],
      // filter_tb: JSON.parse(localStorage.getItem(localStorageKey3)) || {
      //   createJobState:false,
      //   dismanlingState:false,
      //   hitState:false,
      //   trapState:false,
      //   groundState:false,
      //   mixColorState:false,
      //   paintState:false,
      //   assemblyState:false,
      //   polishState:false,
      //   cleanState:false,
      //   qcState:false
      // },
      status_filter:[],
      filter_tb:(this.props.control==='recheck'?FILTER_RECHECK_TB:FILTER_TB),
      pageCount: 1,
      activePage: 1,
      activeTask:{},
      loading: false,
      query: '',
      workerId: '0',
      parkingStatus: '',
      stateDisplay:STATE_MODE.STATE_CHECK_MODE,
      data: JSON.parse(JSON.stringify(mockJson)),
      bData:{},  
      filter:'car_registration_no',              
      headerTitles:  this.defaultHeaderTitles,
      sort: JSON.parse(localStorage.getItem(localStorageKey)) || {sortStatus:'',sortStatus2:'',sortStatus3:''},
      showMec: JSON.parse(localStorage.getItem(localStorageKey2)) || {show:true},
      visible_field:[],
			can_drag:false,
      darg_id:null,
      order_by:'',
      direction:''
    }
    this.workState = []
  }

  componentDidMount() {
    
  }

  getFilterTb(complete=undefined) {
    if (complete!==undefined)
      complete(this.state.filter_tb,this.state.status_filter,this.state.hideFilterNoSel)
  }

  onSortClick(index,e) {
    let {data,headerTitles,sort} = this.state
    if (data.dataList!==undefined&&data.dataList.length>1) {
      if(index==='work_no'){
        if (sort.sortStatus ===''||sort.sortStatus==='desc') {
          headerTitles[0].direction = 'asc'
          sort.sortStatus = 'asc'
          data.dataList.reverse(function(a, b) {
              if(a.work_no < b.work_no) return -1;
              if(a.work_no > b.work_no) return 1;
              return 0;
          })
        } else if (sort.sortStatus==='asc') {
          headerTitles[0].direction = 'desc'
          sort.sortStatus = 'desc'
          data.dataList.reverse()
        }
        headerTitles[4].direction = ''
        headerTitles[6].direction = ''
        sort.sortStatus2 = ''
        sort.sortStatus3 = ''
      } else if(index==='work_date'){
        if (sort.sortStatus2===''||sort.sortStatus2==='desc') {
          headerTitles[4].direction = 'asc'
          sort.sortStatus2 = 'asc'
          data = this.sortDate(data,'work_date','asc')
        } else if (sort.sortStatus2==='asc') {
          headerTitles[4].direction = 'desc'
          sort.sortStatus2 = 'desc'
          data = this.sortDate(data,'work_date','desc')
        }
        headerTitles[0].direction = ''
        headerTitles[6].direction = ''
        sort.sortStatus = ''
        sort.sortStatus3 = ''
      } else if(index==='appointment_date'){
        if (sort.sortStatus3===''||sort.sortStatus3==='desc') {
          headerTitles[6].direction = 'asc'
          sort.sortStatus3 = 'asc'

          data = this.sortDate(data,'appointment_date','asc')
        } else if (sort.sortStatus3==='asc') {
          headerTitles[6].direction = 'desc'
          sort.sortStatus3 = 'desc'

          data = this.sortDate(data,'appointment_date','desc')
        }
        headerTitles[0].direction = ''
        headerTitles[4].direction = ''
        sort.sortStatus = ''
        sort.sortStatus2 = ''
      }
    } 
    let jobControlConfig = {sortStatus:sort.sortStatus,sortStatus2:sort.sortStatus2,sortStatus3:sort.sortStatus3}
    localStorage.setItem(localStorageKey, JSON.stringify(jobControlConfig)) 
    this.setState({data:data,headerTitles:headerTitles,sort:sort})
  }

  loadReportWorkJobControlByQuery(filter='',query='') {
    // this.setState({ loading: true })
    let {status_list} = this.state
    ReportStore.loadReportJobControlByQuery(this.props.control,filter,query,status_list,(result) => {
      if (result.data.length>0) {
        // this.setState({ loading: false })     
        this.loadData(result.data,result.work_state)
      } else {
        this.refs.notificationSystem.addNotification({
          title:this.props.messages['Notice'],
          message: this.props.messages['No Data']+' ' +'"'+query+'"',
          level: 'error',
          position:'tc'
        })
        this.props.onSearchClick()
      }
    },(result) => {
      // this.setState({loading:false})
      this.props.onSearchClick()
    })
  }

  onHeaderClick(field,label=''){
    let activeTask = {value:field,label:label}
    this.setState({activeTask:activeTask})

    if(this.props.onActiveTaskChange!==undefined){
      this.props.onActiveTaskChange(activeTask)
    }
  }

  onSetVisibleField(visible_field) {
    this.setState({visible_field:visible_field})
  }

  loadData(dataList,workState,activeTask={},realonlyActiveTask=true){
      let {data,headerTitles,sort} = this.state
      this.workState = workState
      let newColumn  = this.workState.map((item,index)=>{      
        let onClick = (activeTask.value!==undefined)?this.onHeaderClick.bind(this):undefined;
        if(realonlyActiveTask){
          onClick = undefined
        }
        return {title:item.label,field:item.value,minWidth:'50px',onClick:onClick}
      })

      headerTitles = this.defaultHeaderTitles.concat(newColumn)  
      data.dataList = dataList.map((item,index)=>{
        item.seq = item.seq?item.seq.toString():(index+1).toString()
        return item
      })

      if (sort.sortStatus===''&&sort.sortStatus2===''&&sort.sortStatus3==='') {  
        data = data
        headerTitles[0].direction = ''
        headerTitles[4].direction = ''
        headerTitles[6].direction = ''
      } else {
        if (sort.sortStatus!=='') {
          if (sort.sortStatus===''||sort.sortStatus==='desc') {
            data.dataList.reverse(function(a, b) {
              if(a.work_no < b.work_no) return -1;
              if(a.work_no > b.work_no) return 1;
              return 0;
            })
            headerTitles[0].direction = 'desc'
            headerTitles[4].direction = ''
            headerTitles[6].direction = ''
          } else if (sort.sortStatus==='asc') {
            data = data
            headerTitles[0].direction = 'asc'
            headerTitles[4].direction = ''
            headerTitles[6].direction = ''
          }
        } else if (sort.sortStatus2!=='') {
          if (sort.sortStatus2===''||sort.sortStatus2==='desc') {
            data = this.sortDate(data,'work_date','desc')
            headerTitles[0].direction = ''
            headerTitles[4].direction = 'desc'
            headerTitles[6].direction = ''
          } else if (sort.sortStatus2==='asc') {
            data = this.sortDate(data,'work_date','asc')
            headerTitles[0].direction = ''
            headerTitles[4].direction = 'asc'
            headerTitles[6].direction = ''
          }
        } else if (sort.sortStatus3!=='') {
          if (sort.sortStatus3===''||sort.sortStatus3==='desc') {
            data = this.sortDate(data,'appointment_date','desc')
            headerTitles[0].direction = ''
            headerTitles[4].direction = ''
            headerTitles[6].direction = 'desc'
          } else if (sort.sortStatus3==='asc') {
            data = this.sortDate(data,'appointment_date','asc')
            headerTitles[0].direction = ''
            headerTitles[4].direction = ''
            headerTitles[6].direction = 'asc'
          }
        }
      }
      this.setState({data:data,headerTitles:headerTitles,activeTask:activeTask})
  }

  onSetOrderBy(order_by,direction) {
    this.setState({order_by:order_by,direction:direction})
  }

  sortDate(data,key,direction) { 
            data.dataList.forEach(function(item,index) {
              let date = item[key]
              if (item[key]!==''&&item[key]!==null&&item[key]!==undefined) {
                let d = item[key].substring(0, 2)
                let m = item[key].substring(3, 5)
                let y = item[key].substring(6, 10)
                y = parseInt(y) - 543
                date = y+'-'+m+'-'+d
              } else {
                if (item.added_date!==''&&item.added_date!=null&&item.added_date!==undefined)
                  date = item.added_date.substring(0,10)
              }
              data.dataList[index][key] = date
            })
            data.dataList.sort(function(a, b) {
              if(a[key] < b[key]) return -1;
              if(a[key] > b[key]) return 1;
              return 0;
            })
            if (direction==='desc') {
              data.dataList.reverse(function(a, b) {
                if(a[key] < b[key]) return -1;
                if(a[key] > b[key]) return 1;
                return 0;
              })
            }
            data.dataList.forEach(function(item,index) {
              let date = item[key]
              if (item[key]!==''&&item[key]!==null&&item[key]!==undefined) {
                let d = item[key].substring(8, 10)
                let m = item[key].substring(5, 7)
                let y = item[key].substring(0, 4)
                y = parseInt(y) + 543
                date = d+'/'+m+'/'+y
              } else {
                if (item.added_date!==''&&item.added_date!=null&&item.added_date!==undefined)
                  date = item.added_date.substring(0,10)
              }
              data.dataList[index][key] = date
            })
    return data        
  }

  updateWorkNo(workNo, taskstate) {
    let { data } = this.state
    data.dataList = data.dataList.map((item, index) => {
      if (item.work_no === workNo) {
        return Object.assign(item, taskstate)
      } else {
        return item
      }
    })
    this.setState({ data: data })
  }

  onParkingClick(parkingStatusVal, e) {
    this.setState({
      parkingStatus: parkingStatusVal
    })
  }

  renderParkingRadioButtons() {
    let {messages} = this.props
    const parkingOptions = [
      {
        label: messages['Parked'],
        value: '1'
      },
      {
        label: messages['Not Parked'],
        value: '0'
      }
    ]
    const radioList = parkingOptions.map((parkingStatus, i) => (
      <Radio
        key={i}
        name="parkingStatus"
        inline
        value={parkingStatus.value}
        onClick={this.onParkingClick.bind(this, parkingStatus.value)}
      >
        {parkingStatus.label}
      </Radio>
    ))
    return (
      <FormGroup>
        {radioList}
      </FormGroup>
    )
  }

  onDateChange(dateString, dateMoment) {

  }

  renderPrint() {
    let {messages} = this.props
    return (
      <Button
        bsStyle={null}
        className='bg-blue'
        onClick={this.props.onPrintTable}
      >
        <FontAwesome name='print' />{' '}{messages['Print Report']}
        </Button>
    )
  }

  onQueryChange(e) {
    this.setState({
      query: e.target.value
    })
  }

  renderSearchBox() {
    let {messages} = this.props
    return (
      <FormGroup >
        <ControlLabel>{messages['Search']}</ControlLabel>
        {' '}
        <FormControl
          value={this.state.query}
          type="text"
          placeholder=""
          bsSize="sm"
          onChange={this.onQueryChange.bind(this)}
        />
      </FormGroup>
    )
  }

  onWorkerSelect(val) {
    this.setState({
      workerId: val.value
    })
  }

  renderSelectWorker() {
    let {messages} = this.props
    return (
      <FormGroup style={{ width: '190px' }}>
        <SelectObject
          placeholder={messages['Choose Car Receive Officer']}
          value={this.state.workerId}
          objectList={this.state.data.workerList}
          onChange={this.onWorkerSelect.bind(this)}
        />
      </FormGroup>
    )
  }

  onSearchButtonClick(e) {
    // do sth with this.state.query
  }

  onPrintClick(e) {

  }

  onRowClick(row) {
    
    if (this.props.onRowClick !== undefined) {
      this.props.onRowClick(row,this.workState)
    }
  }

  onPrintClick(){

  }

  onStateMenuItemSelect(value){
    
    this.setState({stateDisplay:value})
  }

  onFilterChange(e){
    this.setState({filter:e.value})
  }

  searchAction(_query='',_func='') {
    let {data,filter,query} = this.state
    // bData = data

    if (_func==='onSearchKeyPress')
      query = _query
    
    if(this.props.onSearchClick!==undefined){
      if (filter===undefined)
        filter = 'car_registration_no'
      
      if (query!==''&&query!==undefined) {
        let newDataList = []
        data.dataList.forEach(function(item,index) {
          let search = ''
          if (filter==='car_registration_no') {
            search = item.car_registration_no
          }else if (filter==='work_no') {
            search = item.work_no
          }else if (filter==='insurer') {
            search = item.customer_name
          }else if (filter==='client') {
            search = item.customer_name
          }

          if (search.search(query)!==-1) {
            newDataList.push(item)
          }
        })

        if (newDataList.length===0) {
          this.loadReportWorkJobControlByQuery(filter,query)
        } else {
          if (this.props.onLoading!==undefined) {
            this.props.onLoading()
          }
          data.dataList = newDataList
          this.setState({data:data})
        }
      } else {
        this.props.onSearchClick()
      }
    }
  }

  onSearchKeyPress(e){
    if (e.charCode == 13) {
      //if (e.target.value!=='') {
        this.setState({query:e.target.value})
        this.searchAction(e.target.value,'onSearchKeyPress')
      //}  
    }  
  }

  onSearchClick(){
    this.searchAction() 
  }

  renderSearch() {
    let {messages} = this.props
    return (
      <Row>
        <Col md={3} className="text-right" >
          <ControlLabel>{messages['Date Appointment']}</ControlLabel>
          <DatePicker style={{ display: 'inline-block' }}
            showIcon={true}
            showFooter={true}
            popPlacement='bottom'
            buddhistEra
            onChange={this.onDateChange.bind(this)} />
        </Col>
        <Col md={9} className="text-left" style={{ paddingLeft: 0 }}>
          <Form inline>
            {' '}
            {this.renderSearchBox()}
            {' '}
            {this.renderSelectWorker()}
            {' '}
            {this.renderParkingRadioButtons()}
            {' '}
            <Button
              type="submit"
              onClick={this.onSearchButtonClick.bind(this)}
            >
              {messages['Search']}
            </Button>
            {' '}
            <Button
              bsStyle={null}
              className='bg-blue'
              onClick={this.onPrintClick.bind(this)}
            >
              <FontAwesome name='print' />{' '}{messages['Print Report']}
          </Button>
          </Form>
        </Col>
      </Row>
    )
  }

  onSetStatusFilter(filter_job_status) {
    let {mode} = this.props
    if (mode==='report') {
      this.setState({status_filter:filter_job_status.map((item,index)=>{
        return item.toString()
      })})   
    }
  }

  onStatusFilterClick(val) {
    let {mode} = this.props
    if (mode==='report') {
      let {status_filter} = this.state
      let findIndex = status_filter.indexOf(val.value)
      if (findIndex!==-1)
        status_filter.splice(findIndex,1)
      else
        status_filter.push(val.value)
      this.setState({status_filter:status_filter})   
    }    
  }

  onHideFilterNoSelChange(val) {
    this.setState({hideFilterNoSel:val})
  }

  renderJobState(status) {
    // 0: 'รอเข้าซ่อม',
    // 1: 'กำลังซ่อม',
    // 2: 'ซ่อมเสร็จในขั้นตอน',
    // 3: 'หยุดชั่วคราว',

    // add more styles below in case jobState is modified in DB
    let {status_filter} = this.state
    const jobStyle = this.props.jobStyle
    const {isMobile,mode} = this.props
    if (Object.keys(jobStyle).length !== Object.keys(this.props.jobState).length)
      return

    const jobStatus = Object.keys(this.props.jobState).map((k, i) => {
      return {
        label: this.props.jobState[k],
        value: k,
        style: jobStyle[k]
      }
    })

    if(isMobile){
      const cJob= jobStatus.map((o, i) => (        
        <div style={{display:'inline',marginRight:'15px'}}><FontAwesome
          name='check-circle'
          style={o.style}
          className={o.style.class}
        />
          {o.label}
        </div>      
      ))
      return (
        <Col md={12} >{cJob}</Col>
      )
    }

    if (typeof status === "undefined"){
      const cJob = jobStatus.map((o, i) => {
        let styles = {padding:'0'}
        if (mode!=='print') {
          styles = {padding:'0 2px',marginRight:(i===jobStatus.length-1?'0':'2px')}
        }
        return(
          <FormGroup style={styles} onClick={this.onStatusFilterClick.bind(this,o)} key={i} className={mode==='print'?'':(status_filter.indexOf(o.value)!==-1?'btn-success btn':'btn-default btn')}>
            <FontAwesome
              name='check-circle'
              style={o.style}
              className={o.style.class}
            />
            <FormControl.Static>
              {o.label}
            </FormControl.Static>
          </FormGroup>
        )  
      })   
      let item = {label:"ยังไม่ได้เริ่ม",style:{color:"",class:""},value:"-1"}
      let style = {padding:'0'}
      if (mode!=='print') {
        style = {padding:'0 2px',marginRight:'2px'}
      }
      return (
        <Col md={6} className='text-right'>  
          <Form inline className={'job-status-print'+(mode==='print'?' print-page':'')}>
            <FormGroup style={{display:(mode==='report'?'':'none')}}>
              <Checkbox
                onChange={this.onHideFilterNoSelChange.bind(this,(this.state.hideFilterNoSel?false:true))}
                checked={this.state.hideFilterNoSel}
                checkboxClass="icheckbox_square-blue"
                increaseArea="20%"
                label={' '+this.props.messages['Not showing other departments']}
              >
              </Checkbox>
            </FormGroup>
            {' '}
            <FormGroup style={style} onClick={this.onStatusFilterClick.bind(this,item)} className={mode==='print'?'':(status_filter.indexOf('-1')!==-1?'btn-success btn':'btn-default btn')}>
              <FontAwesome
                name='check-circle'
              />
              <FormControl.Static>
                ยังไม่ได้เริ่ม
              </FormControl.Static>
            </FormGroup>
            {cJob}
          </Form>
        </Col>
      )   
    }

    const cJob = jobStatus.filter((o) => status === o.value).map((o, i) => (
      <FormGroup key={i}>
        <FontAwesome
          name='check-circle'
          style={o.style}
        />
      </FormGroup>
    ))
    return (
      <Col md={6} className='text-right'>  
        <Form inline className={'job-status-print'+(mode==='print'?' print-page':'')}>
          <FormGroup style={{display:(mode==='report'?'':'none')}}>
              <Checkbox
                onChange={this.onHideFilterNoSelChange.bind(this,(this.state.hideFilterNoSel?false:true))}
                checked={this.state.hideFilterNoSel}
                checkboxClass="icheckbox_square-blue"
                increaseArea="20%"
                label={' '+this.props.messages['Not showing other departments']}
              >
              </Checkbox>
          </FormGroup>
          {' '}  
          {cJob}
        </Form>
      </Col>
    )  
  }

  renderSummary() {
    const summaryArr = [
      {
        label: 'รถผิดนัด',
        value: this.state.data.summary.missingCount,
        style: { color: 'black', background: 'rgb(227, 186, 130)' }
      },
      {
        label: 'รถนัดปัจจุบัน',
        value: this.state.data.summary.appointmentCount,
        style: { color: 'black', background: 'rgb(252, 254, 206)' }
      },
      {
        label: 'รถไม่ถึงนัด',
        value: this.state.data.summary.noShowCount,
        style: { color: 'black', background: 'rgb(125, 195, 150)' }
      },
      {
        label: 'รถซ่อมเสร็จ',
        value: this.state.data.summary.finishCount,
        style: { color: 'black', background: 'rgb(170, 195, 220)' }
      },
      {
        label: 'ยังไม่กำหนดงาน',
        value: this.state.data.summary.unassignCount,
        style: { color: 'black', background: 'white', border: '1px solid black' }
      }
    ]
    return summaryArr.map((obj, i) => (
      <FormGroup key={i}>
        <Badge style={obj.style}>
          {obj.value}
        </Badge>
        <FormControl.Static>
          {obj.label}
        </FormControl.Static>
        {' '}
      </FormGroup>
    ))
  }

  getFilterOptions(){
    let {messages} = this.props
    return [{label:messages['Car Registration'],value:'car_registration_no'},{label:messages['Worksheet Number'],value:'work_no'},{label:messages['Insurer Name'],value:'insurer'},{label:messages['Client'],value:"client"}]
  }

  onShowMecChange() {
    let {showMec} = this.state
    if (showMec.show)
      showMec.show = false
    else
      showMec.show = true
    this.setState({showMec:showMec})
    let jobControlConfig = {show:showMec.show}
    localStorage.setItem(localStorageKey2, JSON.stringify(jobControlConfig))
  }

  onStatusChange(e) {
    let {status_list,filter,query} = this.state
    status_list = e
    this.setState({status_list:status_list},()=>{
      this.loadReportWorkJobControlByQuery(filter,query)
    })
  }

  // getStatusStyles() {
  //   const ReactSelectStyles = () => ({
  //     multiValueLabel: (styles, {data: { isToggled }}) => ({
  //       ...styles,
  //       backgroundColor: isToggled ? 'hotpink' : null,
  //       color: isToggled ? 'white' : null
  //     }),
  //   });
  //   return ReactSelectStyles
  // }

  renderFormSearch() {
    let { filter, query } = this.state
    const {showSearch,showCheckMechanic,messages} = this.props
    
    return (
      <Form className="navbar-left " style={{ display:(showSearch)?'block':'none' }}>
        <FormGroup>
          <div style={{ width: '120px', display: 'inline-block' }}>
            <Select 
              options={this.getFilterOptions()} 
              value={filter}
              placeholder={messages['Choose Category']}
              onChange={this.onFilterChange.bind(this)}
              clearable={false}
            />
          </div>
          &nbsp;
          <div style={{ width: '280px', display: 'inline-block' }}>
            <div className="input-group ">
              <FormControl
                value={query}
                placeholder={messages['Type Search Name']}
                onChange={this.onQueryChange.bind(this)}
                onKeyPress={this.onSearchKeyPress.bind(this)}
              />
              <span className="input-group-btn">
                <Button 
                  className='btn-flat' 
                  onClick={this.onSearchClick.bind(this)}
                >
                  <FontAwesome name='search' />
                </Button>
              </span>
            </div>
          </div>
          &nbsp;
          <div style={{ display:(showCheckMechanic?'inline-block':"none"), verticalAlign:'top' }}>
                  <Checkbox
                    onChange={this.onShowMecChange.bind(this)}
                    checked={this.state.showMec.show}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label={' '+messages['Show Technician Name']}
                  >
                  </Checkbox>
          </div>
          &nbsp;
          <div style={{ minWidth:'150px', display:'inline-block', verticalAlign:'top' }}>
                      <Select
                        className='jcb-select-status'
                        multi={true}
                        removeSelected={false}
                        simpleValue={true}
                        clearable={false}
                        placeholder={messages['Select status']}
                        value={this.state.status_list}
                        options={[
                          {label:messages['Start'],value:'0',className:'select-value-label-default'},
                          {label:messages['Under Repair'],value:'1',className:'select-value-label-warning'},
                          {label:messages['Wait For Delivery'],value:'2',className:'select-value-label-primary'},
                          {label:messages['Work Done'],value:'3',className:'select-value-label-success'},
                          {label:messages['Payment'],value:'5',className:'select-value-label-purple'},
                          {label:messages['Not Yet Quotation'],value:'6',className:'select-value-label-lightgray'},
                          {label:messages['Job Has Not Been Issued'],value:'7',className:'select-value-label-lightyellow'},
                          {label:messages['Car Not Parked'],value:'8',className:'select-value-label-pink'}
                        ]}
                        onChange={this.onStatusChange.bind(this)}
                      />
          </div>
        </FormGroup>
      </Form>
    )
  }

  renderStatus() {
    return (
      <Row>
        <Col md={6} >
          {this.renderFormSearch()}
        </Col>
        {this.renderJobState()}                  
      </Row>
    )
  }

  getPercentageAndRemark(value,remark){
    let odd = (value*10) % 2
    let percentText = ''
    if (odd===1) {
      percentText = Math.floor((value-1.0)*100)+'%'
    } else {
      percentText = Math.ceil((value-1.0)*100)+'%'
    }  
    if(remark!==undefined&&remark!==''){
      return percentText+' ' +remark
    }
    return percentText
  }

  onIconClick(workNo,e) {
    this.refs.jsWork.loadData(workNo)
  }

  renderMechanic(itemState,mechanic){
    if(mechanic!==undefined && mechanic[itemState]!==undefined){
      return (<Label >{mechanic[itemState]}</Label>)
    }else{
      return ('')
    }
  }

  renderRowColumn(item, column, cindex, is_over_date, hasFilterSel) {
    let uniq = item.seq
    let {activeTask,showMec,filter_tb,hideFilterNoSel} = this.state
    let {messages,mode,hideNoSel} = this.props
    let _hideFilterNoSel = (mode==='report'?hideFilterNoSel:hideNoSel)
    let valWork = (mode==='report'?filter_tb[column.field]:this.props.filter_tb[column.field])
    if (mode==='print') {
      if (valWork==='true')
        valWork = true
      else if (valWork==='false')
        valWork = false  
    }
    let _hasFilterSel = (mode==='report'?hasFilterSel:this.props.hasFilterSel)
    let className = (column.className!==undefined)?column.className:''
    // const circleCheckColumns = [
    //   'receivingState','dismanlingState','checkState', 'hitState', 'trapState',
    //   'groundState', 'mixColorState', 'paintState',
    //   'assemblyState', 'polishState', 'cleanState', 'qcState'
    // ]
    const circleCheckColumns = this.workState.map((item,index)=>{
      return item.value
    })
    if (circleCheckColumns.includes(column.field)) { 
      
      if(item['textState']!==undefined && item['textState']!==""){
        if(column.field==='dismanlingState'||column.field==='receivingState') // ||column.field=='receptionState'
          return (<td onMouseEnter={()=>{this.setState({can_drag:true,darg_id:uniq})}}onMouseLeave={()=>{this.setState({can_drag:false,darg_id:null})}} onClick={this.onRowClick.bind(this, item)} key={cindex} colSpan={this.workState.length}><Label bsStyle={'default'}>** {item['textState']}</Label></td>)
        else
          return ('')
      }
      let activeTaskClass = (activeTask.value!==undefined && activeTask.value==column.field)?'col-active-task':''
      const jobStyle = this.props.jobStyle
      let style = jobStyle[Math.floor(item[column.field])]
      if (this.props.control==='workJobOffice') {
        if (item.office_taskstate!=='') {
          //const office_taskstate = item.office_taskstate
          //style = jobStyle[Math.floor(office_taskstate[column.field])]
        }
      }
      if(item[column.field]*1===-2){
        activeTaskClass += ' bg-gray'
      }
      if(style!==undefined){
        let remark = item[column.field+'Remark']
        let labelStyle = {}
        if(remark!==undefined){
          style = Object.assign(style,{position:'relative'})
          labelStyle = {position:'absolute',left:'0px'}
        }
        return (
          <td onMouseEnter={()=>{this.setState({can_drag:true,darg_id:uniq})}}onMouseLeave={()=>{this.setState({can_drag:false,darg_id:null})}} onClick={this.onRowClick.bind(this, item)} key={cindex} className={'text-center '+activeTaskClass}>
            {_hideFilterNoSel&&(!valWork)&&_hasFilterSel
            ?
            ''
            :
            <FormGroup style={style}>
              {item[column.field]=='4'||item[column.field]=='3'||item[column.field]=='2'||item[column.field]=='0'||item[column.field]=='-1'||item[column.field]=='-2'?(
              <FontAwesome
                name='check-circle'
                className={style.class}
              />)
              :(
                <Label style={labelStyle} bsStyle={'warning'}>{this.getPercentageAndRemark(item[column.field],remark)}</Label>
              )}
            </FormGroup>
            }
            <span style={{display:(_hideFilterNoSel&&(!valWork)&&_hasFilterSel?'none':'')}}>
              {showMec.show?this.renderMechanic(column.field,item.mechanic):''}
            </span>  
          </td>
        )
      }else{
        return (<td onMouseEnter={()=>{this.setState({can_drag:true,darg_id:uniq})}}onMouseLeave={()=>{this.setState({can_drag:false,darg_id:null})}} onClick={this.onRowClick.bind(this, item)} className={className+' '+activeTaskClass} key={cindex}></td>)
      }
    }else {
      if (column.field==='appointment_date'&&is_over_date.status) {
        let title = messages['Repair Work']+" "+item['work_no']
        let popoverHoverFocus = (
          <Popover id="popover-trigger-hover-focus" title={title}>
            <strong>{messages['Over Appointment']}</strong>
          </Popover>
        )
        return(
          <td onMouseEnter={()=>{this.setState({can_drag:true,darg_id:uniq})}}onMouseLeave={()=>{this.setState({can_drag:false,darg_id:null})}} onClick={this.onRowClick.bind(this, item)} className={className} key={cindex}>
            <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}>
              <Label bsStyle={is_over_date.style}>{item[column.field]}</Label>
            </OverlayTrigger>  
          </td>
        )
      } else {
        let title = messages['Repair Work']+" "+item['work_no']
        let popoverHoverFocus = (
          <Popover id="popover-trigger-hover-focus" title={title}>
            <strong>{messages['Click Icon To View Worksheet']}</strong>
            <br/>
            <Label bsStyle="info"><FontAwesome name='info' />&nbsp;{messages['Remark']} : {item['remark']===''||item['remark']===undefined?'-':item['remark']}</Label>
          </Popover>
        )
        if (column.field=='work_no') {
          return (
            <td onMouseEnter={()=>{this.setState({can_drag:true,darg_id:uniq})}}onMouseLeave={()=>{this.setState({can_drag:false,darg_id:null})}} className={className} key={cindex}>
              {item['work_no']} <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}><FontAwesome onClick={this.onIconClick.bind(this,item['work_no'])} className="text-blue" name='file-text-o'/></OverlayTrigger>
            </td>
          )
        } else { 
          return (<td onMouseEnter={()=>{this.setState({can_drag:true,darg_id:uniq})}}onMouseLeave={()=>{this.setState({can_drag:false,darg_id:null})}} onClick={this.onRowClick.bind(this, item)} className={className} key={cindex}>{item[column.field]}</td>)
        }  
      }  
    }
  }

  renderColDetail(index,headerTitles,is_over_date,hasFilterSel,item) {
		let {visible_field} = this.state
    return(
      headerTitles.map((column, cindex) => {
        let findState = this.workState.findIndex(x=>x.value===column.field)
        if (visible_field.indexOf(column.field)!==-1||visible_field.length===0||findState!==-1) {
          return(
            this.renderRowColumn(item, column, cindex, is_over_date, hasFilterSel)
          ) 
        } 
      })
    )
  }  

  onMoveRow(id,afterId) {
    let {data} = this.state
    var rows = _.clone(data.dataList);
    var currentRow = _.filter(rows, function (r) { return r.seq === id; })[0];
    var afterRow = _.filter(rows, function (r) { return r.seq === afterId; })[0];

    var currentRowIndex = rows.indexOf(currentRow);
    var afterRowIndex = rows.indexOf(afterRow);

    // remove the current row
    rows.splice(currentRowIndex, 1);
    // put it after
    rows.splice(afterRowIndex, 0, currentRow);

    data.dataList = rows
    this.setState({data: data,order_by:'',direction:''})
  }

  onDropRow(id,afterId){
    
    
    this.onSaveSeq()
    
  }

  onSaveSeq() {
    let {data} = this.state
    let {messages} = this.props
    let itemlist = JSON.parse(JSON.stringify(data.dataList)).map((item,index)=>{
      return {work_no:item.work_no,seq:index+1}
    })
    WorkdocStore.saveJobControlBoardSeq(itemlist,this.props.control,(result)=>{
      if (result.status==='OK') {
        this.refs.notificationSystem.addNotification({
          title:messages['Notice'],
          message:messages['Save sequence successfully'],
          level:'info',
          position:'tc'
        });
      }
    },()=>{
      this.refs.notificationSystem.addNotification({
        title:messages['Notice'],
        message:messages['Save sequence failed'],
        level:'error',
        position:'tc'
      });
    })
  }

  sortRowIndex(itemlist) {
    itemlist = itemlist.map((item,index)=>{
			item.seq = (index+1).toString()
			return item
    })
    return itemlist
  }

  renderRowData(headerTitles) {
    let {data,filter_tb,status_filter,can_drag} = this.state
    let {mode} = this.props
    let {messages} = this.props
    let itemlist = []
    let indexs = []
    let filter_key = []
    let isFilter = false
    let hasFilterSel = false
    if (mode==='report') {
      for (var key in filter_tb) {
        if (filter_tb[key]) { 
          isFilter = true
          hasFilterSel = true
          filter_key.push(key)
        }  
      }
      if (filter_key.length===0&&status_filter.length>0) {
        for (var key in filter_tb) {
          isFilter = true
          filter_key.push(key)  
        }
      }
    }
    if (isFilter&&mode==='report') {
      data.dataList.forEach((item,index)=>{
        filter_key.forEach((sitem,sindex)=>{
          // if (item[sitem]!=='-1'&&item[sitem]!==undefined) {
          //   if (indexs.indexOf(index)===-1) {
          //     indexs.push(index)
          //     itemlist.push(item)
          //   }  
          // }
          /////////////////////////////
          if (status_filter.length>0) {
            let val = item[sitem]*1
            if (val%1>0) {
              let mod = val%1
              val = val-mod
              val = val.toString()
            } else
              val = val.toString()
            if (status_filter.indexOf(val)!==-1&&item[sitem]!==undefined) {
              if (indexs.indexOf(index)===-1) {
                indexs.push(index)
                itemlist.push(item)
              }
            }
          } else {
            if (item[sitem]!=='-1'&&item[sitem]!==undefined) {
              if (indexs.indexOf(index)===-1) {
                indexs.push(index)
                itemlist.push(item)
              }  
            }
          }
        })
      })
    } else 
      itemlist = JSON.parse(JSON.stringify(data.dataList))

    if(itemlist.length===0){
      return (
        <tr><td colSpan={8+(this.workState.length)}>{messages['No Data']}</td></tr>
      )
    }
    return( 
      itemlist.map((item, index) => {
        let is_over_date = {status:false,style:''}
        if (item.appointment_date!==undefined && item.appointment_date!==null && item.appointment_date.length>=10) {
          let app_day = item.appointment_date.substring(0,2)*1
          let app_month = item.appointment_date.substring(3,5)*1
          let app_year = item.appointment_date.substring(6,10)*1-543
          let appointment_date = new Date(app_year,app_month-1,app_day)
          let today = new Date()
          if (appointment_date<today) {
            is_over_date.status = true
            is_over_date.style = 'danger'
          } else if (appointment_date===today) {
            is_over_date.status = true
            is_over_date.style = 'success'
          }
        }
        return <DNDRowItem 
					key={index} 
					id={item.seq}
					item={item}
					can_drag={can_drag}
          moveRow={this.onMoveRow.bind(this)}
          dropRow={this.onDropRow.bind(this)}
					renderColDetail={this.renderColDetail.bind(this,index,headerTitles,is_over_date,hasFilterSel)}
				/>
        // return(
        //   <tr key={index}>
        //     {
        //       headerTitles.map((column, cindex) => {
        //         let findState = this.workState.findIndex(x=>x.value===column.field)
        //         if (visible_field.indexOf(column.field)!==-1||visible_field.length===0||findState!==-1) {
        //           return(
        //             this.renderRowColumn(item, column, cindex, is_over_date, hasFilterSel)
        //           ) 
        //         } 
        //       })
        //     }
        //   </tr>
        // )  
      })   
    )
  }

  onFilterTbClick(field,value) {
    let {mode} = this.props
    let validField = this.workState.findIndex(x=>x.value===field)
    if (mode==='report'&&validField!==-1) {
      let {filter_tb} = this.state
      filter_tb[field] = value
      this.setState({filter_tb:filter_tb},()=>{
        // localStorage.setItem(localStorageKey3, JSON.stringify(filter_tb))
      })
    }  
  }

  onOrderByClick(order_by,direction) {
    let postData = {order_by:order_by,direction:direction}
    WorkdocStore.saveJobcontrolboardOrderBy(postData,(result)=>{
      if (result.status==='OK') {
        if (this.props.onBack!==undefined)
          this.props.onBack()
      }
    })
  }

  renderTable() {
    let {mode} = this.props
    let {headerTitles,activeTask,visible_field,filter_tb,order_by,direction} = this.state
    if(activeTask.value!==undefined){
      headerTitles = headerTitles.map((item,index)=>{
        item['className'] = (item.field == activeTask.value)?'col-active-task':''
        return item
      })
    }
    let order_by_list = ['work_no','car_registration_no','car_detail','customer_name','work_date','work_duration','appointment_date']
    let newHeaderTitles = JSON.parse(JSON.stringify(headerTitles))
    if (visible_field.length>0) {
      newHeaderTitles = []
      headerTitles.forEach((item,index)=>{
        let findState = this.workState.findIndex(x=>x.value===item.field)
        if (visible_field.indexOf(item.field)!==-1||findState!==-1) {
          item = Object.assign({onClick:order_by_list.includes(item.field)?this.onOrderByClick.bind(this):this.onFilterTbClick.bind(this)},item)
          newHeaderTitles.push(item)
        }  
      })
    } else {
      newHeaderTitles = newHeaderTitles.map((item,index)=>{
        item = Object.assign({onClick:order_by_list.includes(item.field)?this.onOrderByClick.bind(this):this.onFilterTbClick.bind(this)},item)
        return item
      })
    }
    return (
      <div className="display-overflow">
        <table className='table table-responsive table-hover table-bordered-solid'>
          {tableHelper.renderHeaderCustomJCBFilter(newHeaderTitles,filter_tb,mode,order_by,direction)}
          <tbody>
            {this.renderRowData(newHeaderTitles)}
          </tbody>
        </table>
      </div>
    )
  }

  onPageChange(page) {

  }

  renderPaging() {
    let {messages} = this.props
    return (
      <Row>
        <Col md={12} >
          <ReactPaginate
            previousLabel={messages['Previous']}
            nextLabel={messages['Next']}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            onPageChange={this.onPageChange.bind(this)}
            containerClassName={"pagination pull-right"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"} />
        </Col>
      </Row>
    )
  }

  onRowWorkClick(item,items) {
    
  }

  renderMobileTable() {
    let {data} = this.state
    let fieldMap = {title:'customer_name',amount:'_work_duration',sub_title:'car_registration_no',date:'appointment_date',status:'',sub_status:'_sub_status'}
    let _data = []
    _data = data.dataList.map((item,index)=>{
      let _item = item
      let _work_duration = (item.work_duration==''?'0':item.work_duration)+' วัน'
      let cLabelHtml = '';
      this.workState.forEach((witem,windex)=>{
        const jobStyle = this.props.jobStyle
        let style = jobStyle[Math.floor(item[witem.value])]
        if(style!==undefined){
          let val = item[witem.value]
          let showPer = (val>1 && val<2)
          let remark = showPer?this.getPercentageAndRemark(val,remark):''
          cLabelHtml += '<span class="label " style="background-color:'+style.color+';margin-right:5px;">'+witem.label+' '+remark+'</span>';
        }
      })
      
      _item = Object.assign({_work_duration:_work_duration,_sub_status:cLabelHtml}, _item)
      return _item
    })
    return(
      <div>
        <ReportMobileTable
          itemlist={_data}
          fieldMap={fieldMap}
          keyIndex={'work_no'}
          numberFormat={false}
          onRowClick={this.onRowWorkClick.bind(this)}
        />
      </div>
    )
  }

  render() {
    let { show, isMobile } = this.props
    if (show === undefined)
      show = true
    
    return (
      <div >
            {this.renderStatus()}
            {isMobile?this.renderMobileTable():this.renderTable()}
            <NotificationSystem ref="notificationSystem" />
            <JSWorkDocViewModal ref="jsWork" title={'แสดงผลใบงาน '} modal={true} fullScreen={true}/>
      </div>
    )
  }

}
JobControlBoardTable.defaultProps = {
  filter_tb: FILTER_TB,
  showSearch: true,
  showWorkNo: true,
  showCheckMechanic:true,
  control: 'workJob',
  jobState: {
    0: 'รอเริ่มงาน',
    1: 'กำลังซ่อม',
    2: 'ซ่อมเสร็จในขั้นตอน',
    3: 'หยุดชั่วคราว'
  },
  jobStyle: {
    0: { color: 'grey', class: 'grey-print' },
    1: { color: 'orange', class: 'orange-print' },
    2: { color: 'blue', class: 'blue-print' },
    3: { color: 'red', class: 'red-print' },
  },
  mode: 'report'
}

export default JobControlBoardTable = connect(
  (state) => ({messages: state.message.view.workdoc.jobcontrol.JobControlBoardTable}),null,null,{withRef:true}
)(JobControlBoardTable);






// WEBPACK FOOTER //
// ./src/view/workdoc/jobcontrol/JobControlBoardTable.js